export default __webpack_public_path__ + "static/media/storageLocation.svg";